export default __webpack_public_path__ + "img/da5ef0ab31ffef5dacb35586c5b2faa8.jpg";